import { createContext, PropsWithChildren, useContext, useState } from 'react';

export const WENA = 'wena';
export const CLM = 'standalone';

type HostMode = typeof CLM | typeof WENA;

type HostContextValue = {
  mode: HostMode;
  isWena: boolean;
  isStandalone: boolean;
  shadowRoot?: ShadowRoot;
};

type HostProviderProps = Readonly<
  PropsWithChildren & {
    mode?: HostMode;
    shadowRoot?: ShadowRoot;
  }
>;

const HostContext = createContext<HostContextValue | null>(null);

export function HostProvider({ children, mode: modeProp, shadowRoot }: HostProviderProps) {
  const [value] = useState<HostContextValue>(() => {
    let mode: HostMode;

    if (modeProp) {
      mode = modeProp;
    } else {
      mode = new URLSearchParams(globalThis.location.search).get('mode') === WENA ? WENA : CLM;
    }

    return {
      mode,
      isWena: mode === WENA,
      isStandalone: mode === CLM,
      shadowRoot,
    };
  });

  return <HostContext.Provider value={value}>{children}</HostContext.Provider>;
}

export function useHost(): HostContextValue {
  const context = useContext(HostContext);

  if (!context) throw new Error('useHost must be used within HostProvider');

  return context;
}
